/* eslint-disable react/no-array-index-key */
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HeadingWithSpaceLarge } from '../../../Components/Headings';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import addIcon from '../../../assets/images/png/add-icon.png';
import './uploadMedicalRecordes.css';
import { SimpleAncer } from '../../../Components/button';

function UploadMedicalRecordes() {
  return (
    <HealthCheckLayout>
      <section className="uploadMedicalRecordes bgLinghtGray">
        <Container>
          <div className="addBox">
            <HeadingWithSpaceLarge text="MEDICAL RECORDS" />
            <Link to="/">
              <img src={addIcon} alt="addIcon" />
            </Link>
          </div>
          <div className="innerBox">
            <Row>
              <Col md={10}>
                <h3>You do not have Medical records uploaded.</h3>
                <SimpleAncer to="/medicalRecordes" text="upload now" />
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default UploadMedicalRecordes;
